export default {"src":"/_next/static/media/mock_star_stroke.624b95d3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};